import { getBoxShadowValue } from './../../../../utils/helpers';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';

const ENABLE_SHADOW = 1;
const DISABLE_SHADOW = 0;
/**
 * ShCssBoxShadow
 */
export class ShCssBoxShadow extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const $self = this.getAtomTarget('read', this);
    const style = this.getAtomModel().style;
    const $activePanel: any = options.$activePanel;
    let value: any;
    if (!this.setting.targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
      return;
    }
    value = HELPER.getValueFromCSS(
      $self,
      style,
      this.setting.property,
      options.screenType,
      this.setting.targetSelector,
    );
    if (value == '') {
      value = $self.find(this.setting.targetSelector).css(this.setting.property);
    }
    if (value !== 'none') {
      if (this.setting.isBoxShadowGroup) {
        value = ENABLE_SHADOW;
        $activePanel
          .find(`input[name="${this.setting.name}"]`)
          .val(ENABLE_SHADOW)
          .attr('value', ENABLE_SHADOW)
          .trigger('value-change');
      }
      const boxShadowValue = getBoxShadowValue($self.find(this.setting.targetSelector));
      const shadowColor = this.setting.shadow ? this.setting.shadow?.color : 'active-outline-color';
      if (shadowColor) {
        $activePanel
          .find(`input[name="${shadowColor}"]`)
          .val(HELPER.rgb2hex(boxShadowValue.color))
          .attr('value', HELPER.rgb2hex(boxShadowValue.color))
          .trigger('value-change');
      }
      const shadowSpread = this.setting.shadow ? this.setting.shadow?.spread : 'active-outline-size';
      if (shadowSpread) {
        $activePanel
          .find(`input[name="${shadowSpread}"]`)
          .val(boxShadowValue.spread)
          .attr('value', boxShadowValue.spread)
          .trigger('value-change');
      }
      // Nếu có thêm các option x,y,blur, .. thì làm tương tự cách Color or spread
    } else {
      if (this.setting.isBoxShadowGroup) {
        value = DISABLE_SHADOW;
        $activePanel
          .find(`input[name="${this.setting.name}"]`)
          .val(DISABLE_SHADOW)
          .attr('value', DISABLE_SHADOW)
          .trigger('value-change');
      }
    }
    return;
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel JQuery
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $activePanel?: JQuery;
      $atom: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const setting: any = this.setting;
    const $atom: any = this.getAtomTarget('', this);
    const $activePanel: any = options.$activePanel;
    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    // Kiểm tra group shadow có được active hay không
    const activeOutline = $activePanel.find(setting.activePanelSelector).val();
    const isActiveOutline = parseInt(activeOutline) == ENABLE_SHADOW ? true : false;
    let outlineSpread: any = '0px'; // default
    let outlineColor: any = 'transparent'; // default
    let $self = $atom;
    if (setting.isSelf) {
      $self = $atom.find(setting.targetSelector);
    } else {
      $self = $atom;
    }
    if (setting.isBoxShadowGroup) {
      if (isActiveOutline) {
        $activePanel
          .find(`input[name="${setting.name}"]`)
          .val(ENABLE_SHADOW)
          .attr('value', ENABLE_SHADOW)
          .trigger('value-change');
        const shadowColor = setting.shadow ? setting.shadow?.color : 'active-outline-color';
        if (shadowColor) {
          outlineColor = $activePanel.find(`input[name="${shadowColor}"]`).val();
        }
        const shadowSpread = setting.shadow ? setting.shadow?.spread : 'active-outline-size';
        if (shadowSpread) {
          outlineSpread = $activePanel.find(`input[name="${shadowSpread}"]`).val();
        }
      } else {
        $activePanel
          .find(`input[name="${setting.name}"]`)
          .val(DISABLE_SHADOW)
          .attr('value', DISABLE_SHADOW)
          .trigger('value-change');
        outlineSpread = '0px';
        outlineColor = 'transparent';
      }
    } else {
      const boxShadowValue: any = getBoxShadowValue($atom.find(setting.targetSelector));
      if (setting.fieldType == 'color') {
        outlineColor = value;
      } else {
        outlineColor = boxShadowValue.color;
      }
      if (setting.fieldType == 'spread') {
        outlineSpread = value;
      } else {
        outlineSpread = boxShadowValue.spread;
      }
      // Nếu có thêm các option x,y,blur, .. thì làm tương tự cách Color or spread
    }

    const valueBoxShadow = {
      blur: 0,
      color: outlineColor,
      spread: parseInt(outlineSpread),
      type: '',
      x: '0',
      y: '0',
    };
    const deOptions = [
      {
        key: setting.property,
        value: valueBoxShadow,
      },
    ];
    style = HELPER.designOptions2Style($self, options.screenType, style, deOptions, setting.targetSelector);

    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
